import { LayoutMetaData } from "../../layout-meta-data/layout-meta-data";
import { Expose, Type } from "../../serialization/class-transformer/decorators";

export class CreateDraftLayoutDataDto {
    @Expose()
    @Type(() => LayoutMetaData)
    metaData: LayoutMetaData;
}

